import { TableCell } from '@mui/material';
import { getTotalActiveHoldCards } from '@utils/helpers';

export default function TeamCardLimitCell({ row }) {
  const totalCards = getTotalActiveHoldCards(row);
  const limit = Number(row.active_cards_limit) || 0;

  const percent =
    limit > 0 ? Math.min(100, Math.round((totalCards / limit) * 100)) : 0;

  function getColor() {
    if (percent <= 50) {
      return 'green';
    }
    if (percent <= 80) {
      return 'yellow';
    }
    return 'red';
  }

  return (
    <TableCell>
      <div className="teamChargedCell">
        <div>
          <p className="teamChargedCell__row">{totalCards}</p>
          <p className="secondary-text">{row.active_cards_limit}</p>
        </div>
        <div className="teamChargedCell__limit">
          <div className={getColor()} style={{ height: `${percent}%` }} />
        </div>
      </div>
    </TableCell>
  );
}
